var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExportImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4 8.9V17l4.1-4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8 7.2c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.7 10.9L6 7.5c.1-.1.2-.1.3 0L8 8.9c.3 0 .5.1.7.1.2 0 .4-.1.5-.2l4.1-3.9c.1-.1.1-.1.2-.1 0 0 .1 0 .2.1l4.8 5.2 1.5 1.5V4.3c0-1.2-1-2.2-2.2-2.2H2.3C1 2 0 3 0 4.3v11.5C0 17 1 18 2.3 18h11.9v-1.5H2.3c-.4 0-.7-.3-.7-.7V11l.1-.1zm2.1-7.7c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zM17.7 18c1.2 0 2.2-1 2.2-2.2v-1.4l-1.5 1.4c0 .4-.3.7-.7.7L16.2 18h1.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8 10.6h12.4v4.6H3.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportImage);
export default __webpack_public_path__ + "static/media/export-image.4ca7cfcc.svg";
export { ForwardRef as ReactComponent };